module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pixel-grid-item",
    style: (_vm.style),
    attrs: {
      "href": "javascript:;"
    }
  }, [(_vm.icon || _vm.hasIconSlot) ? _c('div', {
    staticClass: "pixel-gird__icon"
  }, [_vm._t("icon", [_c('span', {
    class: _vm.icon
  })])], 2) : _vm._e(), _vm._v(" "), (_vm.label || _vm.hasLabelSlot) ? _c('p', {
    staticClass: "pixel-grid__label"
  }, [_vm._t("label", [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  })])], 2) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4a3822e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/grid-item.vue
// module id = 124
// module chunks = 0 3 5